
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import GridHeader from '@/models/gridHeader'

@Component
export default class Iterator extends Vue {
  @Prop() private iteratorFooter!: {} | undefined
  @Prop() private iteratorHeaders!: GridHeader[]
  @Prop() private iteratorItems!: []
  @Prop() private iteratorLoading!: boolean
  @Prop() private iteratorSearch!: string

  private mount() {
  }
}
